import React, { useState, useEffect, useMemo } from 'react'
import { Link } from 'react-router-dom'
import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'
import useOrderStore from '../stores/orderStore'
import { orderStatus } from '../utils/constants'
import { formatPrice } from '../utils/format'


const TransactionHistory = () => {
    const { orders = [], fetchOrders } = useOrderStore()

    const dataFilter = useMemo(() => orderStatus, [])

    const [visible, setVisible] = useState(5)
    const [selectedFilters, setSelectedFilters] = useState([])
    const [searchTerm, setSearchTerm] = useState('')

    useEffect(() => {
        fetchOrders()
    }, [fetchOrders])

    const showMoreItems = () => setVisible((prev) => prev + 5)

    const toggleFilter = (filterKey) => {
        setSelectedFilters((prev) =>
            prev.includes(filterKey) ? prev.filter((item) => item !== filterKey) : [...prev, filterKey],
        )
    }

    const handleSearchChange = (e) => setSearchTerm(e.target.value)

    const filteredTransactions = useMemo(
        () =>
            orders
                .filter((order) => (selectedFilters.length ? selectedFilters.includes(order.status) : true))
                .filter((order) =>
                    order.order_items.some((item) =>
                        searchTerm === '' ? true : item.item.name.toLowerCase().includes(searchTerm.toLowerCase()),
                    ),
                ),
        [orders, selectedFilters, searchTerm],
    )

    return (
        <div>
            <Header />
            <section className="tf-activity s1 tf-section">
                <div className="themesflat-container">
                    <h2 class="tf-title-heading ct style-2 fs-30 mg-bt-10">Giao dịch</h2>
                    <div className="row">
                        <div className="col-lg-8 col-md-8 col-12">
                            {filteredTransactions.length > 0 ? (
                                filteredTransactions.slice(0, visible).map((transaction, index) => (
                                    <div className="transaction-history" key={index}>
                                        <div className="transaction-header">
                                            <div className="title">
                                                <Link to={`/transaction-detail/${transaction.id}`}>
                                                    <h4>Đơn hàng #{transaction.id}</h4>
                                                </Link>
                                            </div>
                                            <div className="status">
                                                <h5>{dataFilter[transaction.status]?.name || 'Unknown'}</h5>
                                            </div>
                                        </div>
                                        {transaction.order_items.map((order_item) => {
                                            const { item } = order_item
                                            return (
                                                <div key={order_item.id}>
                                                    <div className="divider-white"></div>
                                                    <div className="sc-card-activity style1">
                                                        <div className="content">
                                                            <div className="media">
                                                                <img src={item.images[0]?.url} alt={item.name} />
                                                            </div>
                                                            <div className="infor">
                                                                <h5>{item.name}</h5>
                                                                <div className="time">
                                                                    <span>
                                                                        {`${item.float_num || ''} ${item.phase || ''}`}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="price">
                                                            <h5>Giá {formatPrice(item.price)} vnđ</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                        <div className="divider-white"></div>
                                        <div className="transaction-footer">
                                            <div className="total-price">
                                                Thành tiền: <span className="price">{formatPrice(transaction.total_price)} vnđ</span>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="sc-card-activity style1">
                                    <p>Không có đơn hàng nào.</p>
                                </div>
                            )}
                            {visible < filteredTransactions.length && (
                                <div className="col-md-12 wrap-inner load-more text-center">
                                    <Link
                                        to="#"
                                        className="sc-button loadmore fl-button pri-3 mt-10"
                                        onClick={showMoreItems}
                                    >
                                        <span>Load More</span>
                                    </Link>
                                </div>
                            )}
                        </div>
                        <div className="col-lg-4 col-md-4 col-12">
                            <div id="side-bar" className="side-bar style-2">
                                <div className="widget widget-search mgbt-24">
                                    <input
                                        type="text"
                                        placeholder="Tìm kiếm..."
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                </div>
                                <div className="widget widget-filter style-2 mgbt-0">
                                    <h3 className="title-widget">Bộ lọc</h3>
                                    <ul className="box-check">
                                        {Object.entries(dataFilter).map(([key, item], index) => (
                                            <li key={index}>
                                                <Link
                                                    to="#"
                                                    className={`box-widget-filter ${selectedFilters.includes(key) ? 'active' : ''}`}
                                                    onClick={() => toggleFilter(key)}
                                                >
                                                    <i className={item.icon}></i>
                                                    {item.name}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                    <Link
                                        to="#"
                                        className="clear-check btn-filter style-2"
                                        onClick={() => setSelectedFilters([])}
                                    >
                                        Xoá bộ lọc
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default TransactionHistory
